import React from 'react';
import { formatClockDate, formatClockTime } from '../utils/formatDatetime';
import "./RealTimeClock.css";

function RealTimeClock({currentTime}) {
  
  return (
    <div className="card mt-3 bg-transparent">
      <div className="pt-2 bg-transparent">
          <div className="d-flex justify-content-start clock-font">
            <div className='pl-2 pr-3 clock-bg p-1 rounded-left'>
              {formatClockDate(currentTime)}
            </div>
            <div className='clock-bg p-1 pr-2 rounded-right'>
              {formatClockTime(currentTime)}
            </div>
          </div>
      </div>
    </div>
  );
};

export default RealTimeClock;